import { useState } from "react";
// css
import "./mytrips.css";
// others
import { Link, withRouter } from "react-router-dom";
import defaultCardImg from "assets/Images/icons/defaultCardImg.png";
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import guestImg from "assets/Images/icons/users.png";
import { Helmet } from "react-helmet";

//=======================  THIS IS A MANAGE MY TRIPS PAGE ===================================
const ManageTrips = (props) => {
  // user
  let user = props.current_user;
  // state for active tab
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  // dummy data for table head
  const table_head_data = [
    "Yacht's name",
    "Book Number",
    // 'Book Type',
    "Book Date",
    "Due to",
    "Number of guests",
    "Net period",
    "Status",
    "Total Price",
  ];

  // dummy data for table body
  const table_body_data = [
    {
      img: defaultCardImg,
      yacht_name: "Motorboat Azimut 62",
      book_num: "#214564",
      book_type: "IntraDay",
      book_date: "16Oct  09:00AM",
      due_to: "16Oct  10:30AM",
      guest: 6,
      net_period: "1hr 30min",
      status:
        activeTabIndex === 0
          ? "previous"
          : activeTabIndex === 1
          ? "active"
          : "pending",
      total_price: "€ 200",
    },
    {
      img: defaultCardImg,
      yacht_name: "Motorboat Azimut 62",
      book_num: "#214564",
      book_type: "IntraDay",
      book_date: "16Oct  09:00AM",
      due_to: "16Oct  10:30AM",
      guest: 6,
      net_period: "1hr 30min",
      status:
        activeTabIndex === 0
          ? "previous"
          : activeTabIndex === 1
          ? "active"
          : "pending",
      total_price: "€ 200",
    },
    {
      img: defaultCardImg,
      yacht_name: "Motorboat Azimut 62",
      book_num: "#214564",
      book_type: "IntraDay",
      book_date: "16Oct  09:00AM",
      due_to: "16Oct  10:30AM",
      guest: 6,
      net_period: "1hr 30min",
      status:
        activeTabIndex === 0
          ? "previous"
          : activeTabIndex === 1
          ? "active"
          : "pending",
      total_price: "€ 200",
    },
    {
      img: defaultCardImg,
      yacht_name: "Motorboat Azimut 62",
      book_num: "#214564",
      book_type: "IntraDay",
      book_date: "16Oct  09:00AM",
      due_to: "16Oct  10:30AM",
      guest: 6,
      net_period: "1hr 30min",
      status:
        activeTabIndex === 0
          ? "previous"
          : activeTabIndex === 1
          ? "active"
          : "pending",
      total_price: "€ 200",
    },
    {
      img: defaultCardImg,
      yacht_name: "Motorboat Azimut 62",
      book_num: "#214564",
      book_type: "IntraDay",
      book_date: "16Oct  09:00AM",
      due_to: "16Oct  10:30AM",
      guest: 6,
      net_period: "1hr 30min",
      status:
        activeTabIndex === 0
          ? "previous"
          : activeTabIndex === 1
          ? "active"
          : "pending",
      total_price: "€ 200",
    },
  ];

  // CHECK user is not logged in or not
  if (user && user?.isAuth) {
    return (
      <div className="my_trips_page">
        <Helmet>
          <title>Cyan | My Trips</title>
        </Helmet>
        <div className="row">
          <div className="col-12 py-4">
            <h2>Manage My Trips</h2>
          </div>
        </div>
        <div className="row">
          <div className="trips_tab_btn_wrapper d-flex justify-content-between align-items-center">
            <button
              onClick={() => setActiveTabIndex(0)}
              className={`trip_tab_btn ${
                activeTabIndex === 0 ? "trip_active_tab_btn" : ""
              }`}
            >
              Previous trips (5)
            </button>
            <button
              onClick={() => setActiveTabIndex(1)}
              className={`trip_tab_btn ${
                activeTabIndex === 1 ? "trip_active_tab_btn" : ""
              }`}
            >
              Active (5)
            </button>
            <button
              onClick={() => setActiveTabIndex(2)}
              className={`trip_tab_btn ${
                activeTabIndex === 2 ? "trip_active_tab_btn" : ""
              }`}
            >
              Pending for approval (5)
            </button>
          </div>
        </div>
        {/* <div className="row"> */}
        <div className="col-12 trips_table_wrapper">
          <table>
            <thead>
              <tr className="trips_head_row">
                {table_head_data.map((th_name, index) => {
                  return (
                    <th className={index === 0 ? "td-img" : ""} key={index}>
                      {th_name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {table_body_data.map((data, index) => {
                return (
                  <tr className="trips_table_row" key={index}>
                    <td className="td-img">
                      <div className="tbl_Yacht_name mng_td_heading">
                        Yacht’s name{" "}
                      </div>
                      <img
                        className="trip_table_data_img"
                        src={data.img}
                        alt=""
                      />
                      {data.yacht_name}
                    </td>
                    <td className="mng_bookNo_td">
                      <div className="mng_td_heading">Book number</div>
                      {data.book_num}
                    </td>
                    {/* <td className="mng_bookType_td">
                                            <div className="mng_td_heading">Book Type</div>
                                            {data.book_type}</td> */}
                    <td className="mng_bookDate">
                      <div className="mng_td_heading">Book Date</div>
                      {data.book_date}
                    </td>
                    <td className="mng_due_to">
                      <div className="mng_td_heading">Book number</div>
                      {data.due_to}
                    </td>
                    <td className="mang_guest_td">
                      <div className="mng_td_heading">Number of guests</div>
                      <img className="td-guestImg" src={guestImg} alt="" />
                      {data.guest}
                    </td>
                    <td className="manage_net_period_td">
                      <div className="mng_td_heading">Net Period</div>
                      {data.net_period}
                    </td>
                    <td className={` ${data.status}  manage_trip_status_td`}>
                      <div className="mng_td_heading">Status</div>
                      <span className="td-status">{data.status}</span>
                    </td>
                    <td className="view_more_btn_td">
                      <div className="mng_td_heading">Total Price</div>
                      {data.total_price}{" "}
                      <Link to="tripSummary/64" className="td-viewmore-btn">
                        view more
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* </div> */}
      </div>
    );
  } else {
    // if not logged in
    return <NotLoggedIn />;
  }
};

// REDUX CONFIGS
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(ManageTrips));
